import { createContext, useEffect, useState } from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

const AppContext = createContext({
	backdropOpen: false,
	noticeOpen: false,
	CONTEXT_PATH: `${process.env.REACT_APP_CONTEXT_PATH}/interactive`,
	GISSERVER_URL: process.env.REACT_APP_GISSERVER_URL,
});

const AppProvider = ({ children }) => {
	const [backdropOpen, setBackdropOpen] = useState(false);
	const [noticeOpen, setNoticeOpen] = useState(false);
	const [dataSourceOpen, setDataSourceOpen] = useState(false);

	const CONTEXT_PATH = `${process.env.REACT_APP_CONTEXT_PATH}/interactive`;
	const GISSERVER_URL = process.env.REACT_APP_GISSERVER_URL;

	const handleDataSourceClose = () => {
		setDataSourceOpen(false);
	};

	useEffect(() => {
		console.log(dataSourceOpen);
	}, [dataSourceOpen]);

	return (
		<AppContext.Provider
			value={{
				backdropOpen,
				noticeOpen,
				dataSourceOpen,

				setBackdropOpen,
				setNoticeOpen,
				setDataSourceOpen,
				handleDataSourceClose,

				CONTEXT_PATH,
				GISSERVER_URL,
			}}
		>
			{children}
			<Backdrop
				open={backdropOpen}
				xs={{ color: '#fff' }}
				style={{ zIndex: 2 }}
			>
				<CircularProgress color="inherit" />
			</Backdrop>
		</AppContext.Provider>
	);
};

export { AppContext, AppProvider };
